import React, { useState, useEffect } from "react"
import styled from "styled-components"

import PlanFavouriteCard from "../../components/PlanFavouriteCard"
import { numbers } from "../Favourites/Favourites"

import { ApartmentSheetURL } from "../../App"
import { device } from "../../theme/device"
import { useStore } from "../../state/store"

import LogoTitleIcon from "./logo_title.svg"
import RoomImg from "./room.jpg"
import LogoIcon from "./logo.svg"
import MapImg from "./map.jpg"

import "./ShareApartments.css"
import "./Envelope.css"

export const getQueryString = (search = window.location.search, name) => {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i")
  let r = search.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return null
}

export default function ShareApartments(props) {
  const [planData, setPlanData] = useState([])
  const [openEnvelope, setOpenEnvelope] = useState(false)
  const [showEnvelope, setShowEnvelope] = useState(false)
  const setIsShare = useStore(state => state.setIsShare)

  useEffect(() => {
    setIsShare(true)
    fetch(ApartmentSheetURL).then(response => {
      response.text().then(text => {
        const data = text.split("\r\n").map(line => line.split(","))
        const header = data[1]
        const apartmentsLines = data.slice(2)
        const apartments = []

        for (let line of apartmentsLines) {
          const apartment = {}
          for (let x = 0; x < line.length; x++) {
            apartment[header[x]] = line[x]
          }
          apartments.push(apartment)
        }

        const qs_plots =
          getQueryString(props.location.search, "units")
            .split(",")
            .filter(plot => plot) || []

        const favouriteApartments = apartments.filter(a => qs_plots.includes(a.PlotNumber))

        const filtereddata = favouriteApartments.map(apt => ({
          name: "slide_e",
          id: apt.PlotNumber,
          icon: "/assets/images/favourites/icon_apart_block_e.svg",
          floor_no: `${apt.FloorLevel}`,
          flatType: `${apt.FlatType}`,
          bathrooms: `${apt["No. Of Bathrooms (including ensuite)"]}`,
          apartment_no: `apartment ${apt.PlotNumber}`,
          beds: apt[`No. Of Double Bedrooms`],
          blockID: apt.PlotNumberPlanning.split(".")[0],
          bed_type: `${numbers[apt.Beds]} bed`,
          total_internal_area: `${apt["Sqm"]} sq m | ${apt["Sqft"]} sq ft`,
          total_external_area: `${apt["Sqm (Stage 4)"]} sq m | ${apt["Sqft (Stage 4)"]} sq ft`,
          plot_num_planning: apt["PlotNumberPlanning"],
          price: apt["Price"]
        }))

        setPlanData(filtereddata)
        setTimeout(() => {
          setOpenEnvelope(true)
        }, 500)
        setTimeout(() => {
          setShowEnvelope(true)
        }, 1500)
      })
    })
    return () => setIsShare(false)
  }, [])

  return (
    <div className="share_apartments_container">
      <div className="envelope">
        <input className="envelope__check" type="checkbox" checked={openEnvelope} />
        <div className="envelope__flap envelope__flap--inside"></div>
        <div className="envelope__flap">
          <div className="envelope__label_floor">
            <p>Your Select Floor Plans</p>
            <div></div>
          </div>
          <div className="envelope__logo">
            <img src={"/assets/images/landing/postmark.svg"} alt="logo" />
          </div>
        </div>
        <div className={`envelope__letter ${showEnvelope ? "envelope__letter__show" : ""}`}>
          <div className="letter">
            <div className="letter__content">
              <div className="share_apartments">
                <div className="plans-header">
                  <Title>Your Favourite Residences</Title>
                  <LogoTitle src={LogoTitleIcon} />
                </div>
                <div className="plans-container">
                  {planData.map((d, index) => (
                    <PlanFavouriteCard key={index} data={d} />
                  ))}
                </div>
                <div className="home-container">
                  <div className="gallery-image">
                    <img src={RoomImg} alt="gallery" />
                  </div>
                  <div className="text-container">
                    <div className="home">
                      <img src={LogoIcon} alt="" />
                    </div>
                    <div className="text-content">
                      Postmark will create a bustling new neighbourhood in the heart of central
                      London, offering an exciting mix of stylishly designed apartments and
                      carefully curated retail, leisure and commercial spaces. Leading the last
                      major regeneration project to take place in zone 1, Postmark will be delivered
                      over multiple distinct phases, due to be completed by 2025.
                    </div>
                  </div>
                </div>
                <div className="divider"></div>
                <div className="map-container">
                  <img src={MapImg} alt="Map"></img>
                </div>
                <div className="divider"></div>
                <div className="footer-container">
                  <div className="contact">
                    <div
                      style={{
                        marginBottom: 20,
                        fontSize: 20,
                        fontWeight: "bold",
                        fontFamily: "NewParisKingSize-Regular"
                      }}
                    >
                      Contact:
                    </div>
                    <a href="mailto:coronationsquare@taylorwimpey.com">
                      <p>postmark@taylorwimpey.com</p>
                    </a>
                    <p>020 8003 3947</p>
                  </div>
                  <div className="address">
                    <div
                      style={{
                        fontFamily: "NewParisKingSize-Regular",
                        marginBottom: 20,
                        fontSize: 20,
                        fontWeight: "bold"
                      }}
                    >
                      Marketing Suite Address:
                    </div>
                    <p>
                      Postmark Marketing Suite <br />
                      12 Mount Pleasant
                      <br />
                      London
                      <br />
                      WC1X 0BU
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="envelope__back">
          <div className="envelope__back__contact">
            <div>
              <p>
                <strong>Find us at:</strong>
              </p>
              <p>Postmark Marketing Suite,</p>
              <p>12 Mount Pleasant,</p>
              <p>WC1X OBU</p>
            </div>
            <div>
              {/* <p>www.taylorwimpeycentrallondon.com/development/en/postmark</p> */}
              <p>E-mail: postmark@taylorwimpey.com</p>
              <p>Phone: 020 8003 1586</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const LogoTitle = styled.img`
  width: 10vw;
  @media ${device.mobileL} {
    width: 150px;
  }
`
const Title = styled.p`
  margin-top: auto;
  font-size: 3vw;
  font-family: NewParisKingSize-Regular;
  color: #f1f1f1;
  margin: 0;
  padding: 0;
  @media ${device.mobileL} {
    font-size: 1.5em;
  }
`
